'use client';
import { Text } from '@mnd-frontend/ui/publish/components';
import { media } from '@mnd-frontend/ui/publish/utils';
import { SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import { useReportTranslation } from '../../hooks';
import { getDefaultSectionTitle } from '../../utils';

const Wrapper = styled.div<{ $color?: string; $isSubsection?: boolean }>`
  ${({ $color }) => $color && `color: ${$color};`}
  word-break: break-word;
  ${media.greaterThan('tablet')} {
    margin-left: ${props => (props.$isSubsection ? SPACING_3 : '0')};
  }
`;

type Variant =
  | 'reportHeadlineLarge'
  | 'reportDisplaySmall'
  | 'reportDisplayLarge'
  | 'reportLabelSmall';
type AsElement = 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

interface Props {
  section: { __typename: string; id: string; title?: string | null };
  as: AsElement;
  variant: Variant;
  mobileVariant?: Variant;
  color?: string;
  isSubsection?: boolean;
}

export const SectionHeader = ({
  as,
  variant,
  mobileVariant,
  section,
  color,
  isSubsection,
}: Props) => {
  const { t } = useReportTranslation();
  const title = getDefaultSectionTitle({ section, t });

  return (
    <Wrapper $color={color} $isSubsection={isSubsection}>
      <Text as={as} variant={variant} mobileVariant={mobileVariant}>
        {title || t('common_title')}
      </Text>
    </Wrapper>
  );
};
